// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"LogInput_searchForm__2mEcv","searchField":"LogInput_searchField__2JYkz","searchButton":"LogInput_searchButton__2aZox"};